"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const StyledButton = styled_1.default.button({
    display: 'block',
    padding: 5,
    width: '100%',
    height: 36,
    border: 'none',
    borderRadius: 2,
    backgroundColor: '#1c203c',
    appearance: 'none',
    color: 'white',
    textAlign: 'center',
    ':hover': {
        textDecoration: 'none',
        backgroundColor: 'pink',
        cursor: 'pointer',
        color: 'white',
    }
}, ({ fontWeight = 500, outlined, textTransform, theme, }) => ({
    fontWeight,
    textTransform,
    backgroundColor: outlined ? 'transparent' : theme.colors.primary,
    borderColor: outlined ? theme.colors.primary : 'transparent',
    borderWidth: 2,
    borderStyle: 'solid',
    color: outlined ? theme.colors.primary : 'white',
}));
function Button(_a) {
    var { label } = _a, rest = __rest(_a, ["label"]);
    return (react_1.default.createElement(StyledButton, Object.assign({ type: "button" }, rest), label));
}
exports.default = Button;
